import axios from 'axios';

export const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_ENDPOINT || 'http://127.0.0.1:8001'}/api/${process.env.VUE_APP_API_VERSION || 'v1'}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiClientCentral = axios.create({
  baseURL: `${process.env.VUE_APP_API_ENDPOINT || 'http://127.0.0.1:8001'}/api/central/`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Utility to set or clear the Authorization header dynamically
export const setAuthToken = (token: string | null) => {
  if (token) {
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common['Authorization'];
  }
};

// Utility to set or clear the Authorization header dynamically
export const setAuthTokenCentral = (token: string | null) => {
  if (token) {
    apiClientCentral.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete apiClientCentral.defaults.headers.common['Authorization'];
  }
};
